import { addOrUpdateQueueStats } from './helpers'
import { QueueStatsAction } from './actions'
import { QueueStats } from './types'

export interface State {
  queueStats?: QueueStats[]
  pending: boolean
  error: boolean
}

export const initialState: State = {
  queueStats: undefined,
  pending: true,
  error: false
}

export default (state = initialState, action: QueueStatsAction): State => {
  switch (action.type) {
    case 'queueStats.fetch':
      return {
        ...state,
        pending: true,
        queueStats: undefined,
        error: false
      }
    case 'queueStats.fetchFail':
      return {
        ...state,
        pending: false,
        error: true
      }

    case 'queueStats.addQueueStats':
      let items: QueueStats[] = []

      if ('payload' in action) {
        items = action.payload ?? []
      }

      if (!state.queueStats) {
        return {
          ...state,
          queueStats: items
        }
      }

      return {
        ...state,
        queueStats: addOrUpdateQueueStats(state.queueStats, items)
      }

    default:
      return state
  }
}
